// extracted by mini-css-extract-plugin
export default {"bringgDragger":"bringg-dragger_bringgDragger__m1NHR","description":"bringg-dragger_description__TJ9um","button":"bringg-dragger_button__hE9Lo"};